if (!customElements.get("m-social-feed")) {
  class MSocialFeed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSoundToggles();

      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      const wrapper = this.querySelector("[data-wrapper]");
      wrapper.classList.add("swiper-wrapper");
      this.initSlider();
    }

    initSoundToggles() {
      this.querySelectorAll("[data-sound-toggle]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const card = btn.closest(".m-social-feed__card");
          const video = card && card.querySelector("[data-video]");
          if (!video) return;
          video.muted = !video.muted;
          card.classList.toggle("is-unmuted", !video.muted);
        });
      });
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          spaceBetween: 16,
          freeMode: {
            enabled: true,
            sticky: false,
          },
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            600: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: items > 3 ? 3 : items,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: items,
              spaceBetween: 24,
            },
          },
        });
      }
    }
  }

  customElements.define("m-social-feed", MSocialFeed);
}
